import { render, staticRenderFns } from "./GroupCourse.vue?vue&type=template&id=6e26ab7a&scoped=true&"
import script from "./GroupCourse.vue?vue&type=script&lang=js&"
export * from "./GroupCourse.vue?vue&type=script&lang=js&"
import style0 from "./GroupCourse.vue?vue&type=style&index=0&id=6e26ab7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e26ab7a",
  null
  
)

export default component.exports